import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';
import ListAltIcon from '@material-ui/icons/ListAlt';

import {
  PERMISSAO_TELA_PRODUTOS_LISTAR,
  PERMISSAO_TELA_FAMILIAS_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_LISTAR,
  PERMISSAO_TELA_TARAS_BALANCA_LISTAR,
  PERMISSAO_TELA_TABELA_LUCRO_LISTAR,
  PERMISSAO_TELA_BAIXAR_LISTAR,
  PERMISSAO_TELA_LOCAIS_LISTAR,
  PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR,
  PERMISSAO_TELA_SETORES_LISTAR,
  PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR,
  PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR,
  PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR,
  PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR,
  PERMISSAO_TELA_VALIDADES_LISTAR,
  PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR,
  PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuProduto = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Itens de venda"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {/* A tela antiga de produtos (`produtos`) continua registrada no App.js, só não aparece mais no menu. */}
    {permissoes[PERMISSAO_TELA_PRODUTOS_LISTAR] && hasResource('produtos-v2')}
    {permissoes[PERMISSAO_TELA_FAMILIAS_LISTAR] &&
      hasResource('familias_produtos')}
    {permissoes[PERMISSAO_TELA_CATEGORIAS_LISTAR] && hasResource('categorias')}
    {permissoes[PERMISSAO_TELA_TARAS_BALANCA_LISTAR] &&
      hasResource('taras_balanca')}
    {permissoes[PERMISSAO_TELA_TABELA_LUCRO_LISTAR] &&
      hasResource('tabela_lucros')}
    {permissoes[PERMISSAO_TELA_BAIXAR_LISTAR] && (
      <StyledMenuItemLink
        key="baixar"
        to="/baixar"
        primaryText="Baixar"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_LOCAIS_LISTAR] && hasResource('locais_setores')}
    {permissoes[PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR] &&
      hasResource('sugestao_produtos')}
    {permissoes[PERMISSAO_TELA_SETORES_LISTAR] && hasResource('setores')}
    {permissoes[PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR] &&
      hasResource('produtos-caixaria-verificacao')}
    {permissoes[PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR] &&
      hasResource('liberacoes_de_precos')}
    {permissoes[PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR] &&
      hasResource('conferencias_grandes_pesagens')}
    {permissoes[PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR] &&
      hasResource('historico_precificacoes')}
    {permissoes[PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR] &&
      hasResource('verbas_produtos')}
    {permissoes[PERMISSAO_TELA_VALIDADES_LISTAR] &&
      hasResource('validades-produtos')}
    {permissoes[PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR] &&
      hasResource('notas-fiscais-testes')}
    {permissoes[PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR] &&
      hasResource('movimentacoes-estoque')}
    {permissoes[PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR] &&
      hasResource('conferencia_propriedade_produtos')}
  </SubMenu>
);

export default SubMenuProduto;
